import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  searchDate: '',
  searchLine: '',
  searchProductName: '',
  searchPackageNumbers: '',
  searchPackageUnitValue: '',
  searchInsurancePrice: '',
  searchPickupMethod: '',
  searchCustomerCode: '',
  searchStatusRateName: '',
  searchCnShippingCode: '', // Add this field
  searchVnShippingCode: '', // Add this field
  searchStatusName: '', // Add this field
   searchPackageUnitM3: '', // Add this field
    searchIsDeleted: false, // Add the isDeleted field, defaulting to false
    
  itemsPerPage: 50, // Add itemsPerPage to the state
    isFilterApplied: false,
     isFilterAppliedFile: false,
};

const filterSlice = createSlice({
  name: 'filters',
  initialState,
  reducers: {
    // Action to set all filters, including itemsPerPage
    setFilters: (state, action) => {
      state.searchDate = action.payload.searchDate || '';
      state.searchLine = action.payload.searchLine || '';
      state.searchProductName = action.payload.searchProductName || '';
      state.searchPackageNumbers = action.payload.searchPackageNumbers || '';
      state.searchPackageUnitValue = action.payload.searchPackageUnitValue || '';
      state.searchInsurancePrice = action.payload.searchInsurancePrice || '';
      state.searchPickupMethod = action.payload.searchPickupMethod || '';
      state.searchCustomerCode = action.payload.searchCustomerCode || '';
      state.searchStatusRateName = action.payload.searchStatusRateName || '';
      state.searchCnShippingCode = action.payload.searchCnShippingCode || '';
      state.searchVnShippingCode = action.payload.searchVnShippingCode || '';
      state.searchStatusName = action.payload.searchStatusName || '';
        state.searchPackageUnitM3 = action.payload.searchPackageUnitM3 || ''; // Set searchPackageUnitM3
            state.searchIsDeleted = action.payload.searchIsDeleted !== undefined ? action.payload.searchIsDeleted : false; // Set searchIsDeleted, default false if not provided
        state.itemsPerPage = action.payload.itemsPerPage ||50; // Set itemsPerPage (default to 50 if not provided)
    if (typeof action.payload.isFilterApplied === 'boolean') {
        state.isFilterApplied = action.payload.isFilterApplied;
      }
       if (typeof action.payload.isFilterAppliedFile === 'boolean') {
        state.isFilterAppliedFile = action.payload.isFilterAppliedFile;
      }
    },
    // Action to reset all filters, including itemsPerPage
    resetFilter: (state) => {
      state.searchDate = '';
      state.searchLine = '';
      state.searchProductName = '';
      state.searchPackageNumbers = '';
      state.searchPackageUnitValue = '';
      state.searchInsurancePrice = '';
      state.searchPickupMethod = '';
      state.searchCustomerCode = '';
      state.searchStatusRateName = '';
      state.searchCnShippingCode = '';
      state.searchVnShippingCode = '';
      state.searchStatusName = '';
      state.searchPackageUnitM3 = ''; // Reset searchPackageUnitM3
   state.searchIsDeleted = false;
      state.itemsPerPage = 50; // Reset itemsPerPage to default 50
       state.isFilterApplied = false;
          state.isFilterAppliedFile = false;
    },
    // Action to update only the itemsPerPage value
    setItemsPerPage: (state, action) => {
      state.itemsPerPage = action.payload; // Update the itemsPerPage value
    },
    setIsFilterAppliedOrder: (state, action) => {
      state.isFilterApplied = action.payload;  // Action riêng để set isFilterApplied
    },
       // Action mới riêng cho isFilterAppliedFile
    setIsFilterAppliedFile: (state, action) => {
      state.isFilterAppliedFile = action.payload;
    },

    resetFilterFile: (state) => {
      state.isFilterAppliedFile = false;

    }
    
  }
});
export const { setFilters, resetFilter, setItemsPerPage , setIsFilterAppliedOrder,setIsFilterAppliedFile,
  resetFilterFile } = filterSlice.actions;
export default filterSlice;
